import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';

const Row = (stackProps: React.ComponentProps<typeof Stack>) => {
  return <Stack {...stackProps} direction="row" />;
};

export { Row };
